/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_History_EmptyInputs */

const en_us2_exercise_sheet_history_empty = /** @type {(inputs: Exercise_Sheet_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do 1 workout with this exercise to see its history.`)
};

const pt_br2_exercise_sheet_history_empty = /** @type {(inputs: Exercise_Sheet_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça 1 treino com este exercício para ver o seu histórico.`)
};

const es_419_exercise_sheet_history_empty = /** @type {(inputs: Exercise_Sheet_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haz 1 entrenamiento con este ejercicio para ver su historial.`)
};

const pt_pt2_exercise_sheet_history_empty = /** @type {(inputs: Exercise_Sheet_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faz 1 treino com este exercício para veres o histórico.`)
};

const fr_fr2_exercise_sheet_history_empty = /** @type {(inputs: Exercise_Sheet_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fais 1 séance avec cet exercice pour voir son historique.`)
};

const de_de2_exercise_sheet_history_empty = /** @type {(inputs: Exercise_Sheet_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mach 1 Training mit dieser Übung, um ihren Verlauf zu sehen.`)
};

const it_it2_exercise_sheet_history_empty = /** @type {(inputs: Exercise_Sheet_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fai 1 allenamento con questo esercizio per vederne lo storico.`)
};

/**
* | output |
* | --- |
* | "Do 1 workout with this exercise to see its history." |
*
* @param {Exercise_Sheet_History_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_history_empty = /** @type {((inputs?: Exercise_Sheet_History_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_History_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_history_empty(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_history_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_history_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_history_empty(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_history_empty(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_history_empty(inputs)
	return en_us2_exercise_sheet_history_empty(inputs)
});
export { exercise_sheet_history_empty as "exercise-sheet.history_empty" }